import { useState } from 'react';
import { OutlinedCTAButton } from '~/components/OutlinedCTALink';
import { useTrackEvent } from '~/globals/trackEvent';

export const LoadMoreButton = ({ onClick }: { onClick: (event?: any) => void }) => {
  const [numClicks, setNumClicks] = useState(0);
  const trackEvent = useTrackEvent();

  return (
    <OutlinedCTAButton
      onClick={(event) => {
        onClick(event);
        const newNumClicks = numClicks + 1;
        setNumClicks(newNumClicks);
        trackEvent('click_button', {
          count: newNumClicks,
        });
      }}
      eventAction="Load More"
    >
      Load More
    </OutlinedCTAButton>
  );
};
